import { render, staticRenderFns } from "./ButtonInputRichText.vue?vue&type=template&id=2fd123c6&"
import script from "./ButtonInputRichText.vue?vue&type=script&lang=js&"
export * from "./ButtonInputRichText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports